<template lang="">
  <main id="main" style="margin-top: 80px">
    <FuneralInvitationEditForm :funeralInvitationSeq=funeralInvitationSeq />
  </main>
</template>
<script>
import FuneralInvitationEditForm from '@/components/funeral/FuneralInvitationEditForm.vue';
export default {
    props: {
        funeralInvitationSeq: {
            type: String,
            required: true
        }
    },

    components: {
        FuneralInvitationEditForm
    }
}
</script>
<style lang="">
    
</style>